/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".modeso-title[_ngcontent-%COMP%]{margin-bottom:1em}.modeso-title[_ngcontent-%COMP%]   h1[_ngcontent-%COMP%]{font-size:clamp(2rem,7.5vw,2.5rem);font-weight:700}"];
export { styles as styles };
